module.exports = __webpack_public_path__ + "static/img/arrow_right.9dffe1eb.svg";